import React from 'react';
import Iconfont from '../components/Iconfont/Iconfont';
import {Avatar, Badge, Layout, Menu, Modal, Popover} from 'antd';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {HelpMenu, PersonMenu} from '../components/ck/CkMenu'
import InformationList from '../containers/information/InformationList'
import {setInformationNumber} from "../redux/actions/informationNumber";
import PropTypes from "prop-types";
import QRCode from "../components/qr-code/QRCode";
import Logo2 from "../style/imgs/logo2.png"



class CkNavbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSubAccount:props.loginedUser.data ? props.loginedUser.data.subAccount : false,
            informationVisible:false,
            dotStatus:false,
        }
    }
    componentDidMount() {
        if(!this.state.isSubAccount){
            // setTimeout(()=>this.addListenter(),10000)
        }

    }

    componentWillReceiveProps(nextProps) {

    }
    addListenter =()=>{
        this.context.getCkSocket().addWsMsgListener("EVENT_ATTENDEE_IMT_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("EVENT_INVITEE_IMT_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("EVENT_ATTENDEE_EXP_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("USER_CONTACT_IMP_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("EVENT_ATTENDEE_QRCODE_EXT_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("EVENT_PRICE_DRAW_EXP_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("EVENT_PRICE_ROLL_EXP_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("EVENT_ALLOT_EXP_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("BROADCAST_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("SURVEY_EXP_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("VOTE_EXP_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("LUCKYMONEY_EXP_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("EVENT_ATTENDEE_BADGE_EXT_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("REWARD_DETAIL_EXP_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("MARKET_PURCHASE_EXP_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("GUESS_PLAYER_EXP_NTF", this.setDotStatus);
        this.context.getCkSocket().addWsMsgListener("EVENT_ORDER_EXP_NTF", this.setDotStatus);
    }
    setDotStatus=(msg)=>{
        if(msg){
            this.setState({dotStatus:true})
        }
    }
    hideModal = () => {
        this.setState({
            informationVisible: false,
        });
    }

    render() {
        return (
            <nav className={"navbar layout-header"}>
                <div className="navbar-header">
                    {this.props.navbarHeader}
                </div>
                <div className="navbar-title">
                    {this.props.navbarMenu ? null : this.props.navbarTitle}
                </div>
                <div className="navbar-menu">
                    {this.props.navbarMenu}
                </div>
                <div className="nav navbar-right">
                    <Menu
                        theme="light"
                        mode="horizontal">
                        <Menu.Item key="1">
                            <Popover placement="bottomRight" title={"扫描二维码"} content={
                                <div style={{fontSize:12,color:'#959595',textAlign:'center',width:250}}>
                                    <div style={{marginBottom:10}}>
                                        <QRCode
                                            value={`https://a.app.qq.com/o/simple.jsp?pkgname=com.xlzg.sign`}
                                            size={85}
                                            refName="register-cert-qr-canvas"
                                            logoWidth={22}
                                            logoHeight={22}
                                            logo={Logo2}
                                        />
                                        <p>扫码下载Android和IOS APP</p>
                                        <p>方便主办方移动端管理活动</p>
                                    </div>
                                    <div style={{marginBottom:10}}>
                                        <img style={{width:100}} src="https://img.qdj8.cn/wxghh.jpg" alt=""/>
                                        <p>关注签到家可以查看您报名</p>
                                        <p>签到情况和接收最新资讯</p>
                                    </div>
                                    <div>
                                        <img style={{width:100}} src="https://img.qdj8.cn/wxxx.jpg" alt=""/>
                                        <p>参与人使用的小程序</p>
                                        <p>查询活动门票和管理个人信息等</p>
                                    </div>
                                </div>
                            } trigger="click">
                                <div>
                                    <Iconfont libname="ckicon" type="erweima"/>
                                </div>
                            </Popover>
                        </Menu.Item>
                        <Menu.Item key="2">

                                <div>
                                    <Badge dot={this.state.dotStatus}>
                                        <Iconfont libname="s7icon" type="bell" onClick={()=>this.setState({
                                            informationVisible:true,
                                        },()=>{
                                            this.setState({dotStatus:false})
                                        })}/>
                                    </Badge>
                                </div>

                        </Menu.Item>
                        <Menu.Item key="3">
                            <Popover placement="bottomRight" content={<HelpMenu/>} trigger="click">
                                <div>
                                    <Iconfont libname="s7icon" type="help1"/>
                                </div>
                            </Popover>
                        </Menu.Item>
                        <Menu.Item key="4">
                            <Popover placement="bottomRight" content={<PersonMenu/>} trigger="click">
                                <div>
                                    <Avatar className="logined-user-avatar" size="default" icon="user"  src={this.props.loginedUser.data ? this.props.loginedUser.data.avatarUrl : null}/>
                                    <Iconfont libname="s7icon" type="angle-down"/>
                                </div>
                            </Popover>
                        </Menu.Item>
                    </Menu>
                </div>

                <Modal
                    width={600}
                    bodyStyle={{paddingTop: 10}}
                    title="通知提醒"
                    visible={this.state.informationVisible}
                    onCancel={this.hideModal}
                    footer={null}
                >
                    {this.state.informationVisible && <InformationList hide={this.hideModal}/>}

                </Modal>
            </nav>
        )


    }
}
CkNavbar.contextTypes = {
    getCkSocket: PropTypes.func
};
const mapStateToPorps = state => {
    const informationNumber = state.informationNumber;
    const loginedUser = state.loginedUser;
    return {informationNumber, loginedUser};
};
const mapDispatchToProps = dispatch => ({
    setInformationNumber: bindActionCreators(setInformationNumber, dispatch),

});

export default connect(mapStateToPorps, mapDispatchToProps)(CkNavbar);



// WEBPACK FOOTER //
// ./src/components/CkNavbar.jsx